import React from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@chakra-ui/react";
import { IoLanguageSharp } from "react-icons/io5";

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || "en";
  const isMarathi = currentLang.startsWith("mr");

  const toggleLanguage = () => {
    i18n.changeLanguage(isMarathi ? "en" : "mr");
  };

  return (
    <Tooltip
      label={isMarathi ? "Switch to English" : "मराठीत बदला"}
      placement="bottom"
    >
      <IconButton
        aria-label="Toggle language"
        icon={<IoLanguageSharp />}
        onClick={toggleLanguage}
        variant="ghost"
        colorScheme="blue"
        fontSize="20px"
        borderRadius="full"
      />
    </Tooltip>
  );
};

export default LanguageToggle;
